import Image from 'next/image';
import Icon from './close_white.svg?url';
import type { SvgImageProps } from '../_type';

export const CloseWhiteImage: React.FC<SvgImageProps> = ({ alt, ...props }) => (
  <Image src={Icon} alt={alt} {...props} />
);
